/* 数量とカートボタンを横に並べ、下に在庫を出す（2026-10 くろ） */
(function(){
  function setup(){
    var cart = document.querySelector('.product-information .product-add-to-cart-container');
    if(!cart || cart.closest('.kr-buyrow')) return;
    var qty = document.querySelector('.product-information [id^="quantity-"]');
    if(!qty) return;
    var row = document.createElement('div');
    row.className = 'kr-buyrow';
    cart.parentNode.insertBefore(row, cart);
    row.appendChild(qty);
    row.appendChild(cart);

    var stock = document.createElement('p');
    stock.className = 'kr-stock';
    row.parentNode.insertBefore(stock, row.nextSibling);
    var btn = cart.querySelector('.single-add-to-cart-button');
    function update(){
      if(!btn) return;
      var out = btn.disabled || btn.hasAttribute('disabled');
      stock.textContent = out ? '売り切れ' : '在庫あり';
      stock.classList.toggle('is-out', out);
    }
    update();
    if(btn) new MutationObserver(update).observe(btn, {attributes:true, attributeFilter:['disabled'], childList:true, subtree:true});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* 商品カードのレビュー：点数を小数1けたに（★★★★★ 5.0（1）） 2026-10-13 くろ */
(function(){
  function fix(root){(root||document).querySelectorAll('product-card .jdgm-prev-badge:not([data-kr-r])').forEach(function(b){var a=parseFloat(b.getAttribute('data-average-rating'));if(!isNaN(a))b.setAttribute('data-kr-r',(Math.round(a*10)/10).toFixed(1));});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){fix()});}else{fix();}
  try{new MutationObserver(function(){fix()}).observe(document.body,{childList:true,subtree:true});}catch(e){}
})();

/* カートの数：0件のときは丸を出さない（お気に入りとそろえる） 2026-10-13 くろ */
(function(){
  function sync(){document.querySelectorAll('.thb-item-count').forEach(function(e){if(e.textContent.trim()==='0'){e.setAttribute('data-kr0','')}else{e.removeAttribute('data-kr0')}});}
  if(document.readyState!=='loading'){sync()}else{document.addEventListener('DOMContentLoaded',sync)}
  try{new MutationObserver(sync).observe(document.documentElement,{childList:true,subtree:true,characterData:true});}catch(e){}
})();
